export * from './kotahi-selects-linescape-sailing-schedules-api';


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/kotahi-selects-linescape-sailing-schedules-api/index.ts